import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  clients: null,
  projects: null,
  commodities: null,
  states: null,
  districts: null,
  samplers: null,
  labs: null,
};

const reportFilterSlice = createSlice({
  name: "reportFilter",
  initialState,
  reducers: {
    fetchClients: (state, action) => {
      state.loading = true;
      state.clients = null;
    },
    fetchClientsSuccess: (state, action) => {
      state.loading = false;
      state.clients = action.payload?.data?.document;
    },
    fetchClientsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchProjects: (state, action) => {
      state.loading = true;
      
    },
    fetchProjectsSuccess: (state, action) => {
      state.loading = false;
      state.projects = action.payload?.data;
    },
    fetchProjectsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearProjects: (state) => {
      state.projects = null;
    },
    fetchCommodities: (state, action) => {
      state.loading = true;
      state.commodities = null;
    },
    fetchCommoditiesSuccess: (state, action) => {
      state.loading = false;
      state.commodities = action.payload?.data?.document;
    },
    fetchCommoditiesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchStates: (state, action) => {
      state.loading = true;
      state.states = null;
    },
    fetchStatesSuccess: (state, action) => {
      state.loading = false;
      state.states = action.payload?.data?.document;
    },
    fetchStatesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDistricts: (state, action) => {
      state.loading = true;
      state.districts = null;
    },
    fetchDistrictsSuccess: (state, action) => {
      state.loading = false;
      state.districts = action.payload?.data?.districts;
    },
    fetchDistrictsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearDistricts: (state) => {
      state.districts = null;
    },
    fetchSamplers: (state, action) => {
      state.loading = true;
    },
    fetchSamplersSuccess: (state, action) => {
      state.loading = false;
      state.samplers = action.payload;
    },
    fetchSamplersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearSamplers: (state) => {
      state.samplers = null;
    },
    fetchLabs: (state, action) => {
      state.loading = true;
    },
    fetchLabsSuccess: (state, action) => {
      state.loading = false;
      state.labs = action.payload?.data?.document;
    },
    fetchLabsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearLabs: (state) => {
      state.labs = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = reportFilterSlice;